import React, { useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { useAuth } from '../../context/AuthContext';
import { jwtDecode } from 'jwt-decode';
import loginStaticData from "./data";
import "../../components/Companies/Index.css";
import { toast, ToastContainer } from 'react-toastify';  // Import toast for notifications
import * as amplitude from '@amplitude/analytics-browser';

const LoginScreen = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { user, setUser } = useAuth();
  const {
    logo,
    headings,
    inputs,
    button,
    googleSignIn,
    icons,
    forgotPassword,
    continueText,
  } = loginStaticData;

  // Handle OAuth redirect callback
  useEffect(() => {
    // Check for token in URL (from OAuth redirect)
    const params = new URLSearchParams(window.location.search);
    const token = params.get('token');
    const error = params.get('error');
    const message = params.get('message');

    if (error) {
      // Show the error message as a toast
      toast.error(message || 'An unknown error occurred.', {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
    }
    console.log("Running useEffect")

    if (token) {
      console.log("Token found")
      // Decode token to check isNewUser flag
      const decodedToken = jwtDecode(token);
      setUser({ token, ...decodedToken });

      // Remove token from URL
      window.history.replaceState({}, document.title, window.location.pathname);

      console.log(`decodedToken`, decodedToken)
      // Redirect based on isNewUser flag
      if (decodedToken.isNewUser) {
        navigate('/onboarding', { replace: true });
      } else {
        navigate('/leads', { replace: true });
      }
      // navigate('/signup', { replace: true });
    }
  }, [navigate, setUser, location.state]);

  // Handle user state changes and Amplitude tracking
  useEffect(() => {
    console.log(`user ========>>>>`, user)
    if (user) {
      // Set user identity in Amplitude
      amplitude.setUserId(user.email);
      amplitude.track('User Login', {
        loginMethod: 'oauth',
        isNewUser: user.isNewUser
      });

      if (user.isNewUser) {
        navigate('/onboarding', { replace: true });
      } else {
        navigate('/leads', { replace: true });
        // navigate('/onboarding', { replace: true });
      }
    }
  }, [user, navigate, location.state]);

  const handleGoogleLogin = () => {
    // Redirect to your backend Google OAuth route
    console.log("Running handleGoogleLogin")
    // window.location.reload();
    window.location.href = `${process.env.REACT_APP_API_URL}/auth/google`;
  };

  const handleGoogleSignup = () => {
    navigate('/onboarding')
    // window.location.href = `${process.env.REACT_APP_API_URL}/auth/google?action=signup`;
  };

  // const handleRegularLogin = () => {
  //   handleGoogleLogin(); // For now, regular login also uses Google
  // };


  const handleRegularLogin = () => {
    // handleGoogleLogin(); // For now, regular login also uses Google
    navigate('/onboarding')
  };


  return (
    <div className="max-w-8xl p-4 mx-auto add-shadow-color">
      {/* Logo Section */}
      <div className="flex">
        <img src={logo.src} alt={logo.alt} className="w-[7rem]" />
      </div>

      {/* Content Grid */}
      <div className="grid grid-cols-1 lg:grid-cols-8 mt-[15%] pb-[25%]">
        {/* Left Side Content */}
        <div className="lg:col-span-5 flex flex-col justify-start">
          <div className="flex items-center text-white px-10 lg:px-16 xl:px-28 mb-4">
            <div className="flex flex-col text-black space-y-14">
              {/* Heading */}
              <div
                className="font-[800] flex flex-col space-y-2"
                style={{
                  backgroundColor: "transparent",
                  fontSize: "3.2rem",
                  lineHeight: "3rem",
                }}
              >
                {headings.main.map((line, index) => (
                  <span key={index}>{line}</span>
                ))}
            </div>

              {/* Subtext */}
              <div className="flex flex-col text-black">
                <span className="text-lg">{headings.sub[0]}</span>
                <span
                  className="text-lg"
                // dangerouslySetInnerHTML={{ __html: headings.sub[1] }}
                >Get started <span class="text-[#CB90FC] cursor-pointer" onClick={() => handleGoogleSignup()}>here.</span></span>
              </div>
            </div>
          </div>
        </div>

        {/* Right Side Content */}
        <div className="lg:col-span-3 flex flex-col justify-center">
          <div className="flex items-center text-white px-4 lg:px-10">
            <div className="flex flex-col text-black w-full max-w-xs">
              {/* <div className="flex flex-col text-black w-full max-w-sm"> */}
              {/* Email Input */}
              {/* <input
                    type={inputs.email.type}
                    placeholder={inputs.email.placeholder}
                    className="placeholder-[#cb90fc] bg-[#F1EEF6] text-[#2F0E60] min-w-full px-4 py-4 rounded-xl focus:outline-none text-sm"
                /> */}

              {/* Password Input */}
              <div className="flex flex-col mt-8">
                {/* <div className="relative flex items-center">
                    <input
                        type={inputs.password.type}
                        placeholder={inputs.password.placeholder}
                        className="placeholder-[#cb90fc] bg-[#F1EEF6] text-[#2F0E60] min-w-full px-4 py-4 rounded-xl focus:outline-none text-sm"
                    />
                    <span className="absolute right-4 text-[#9C9C9C] cursor-pointer">
                    <img src={icons.passwordHide} alt={icons.alt}/>
                  </span>
                  </div> */}

                {/* Forgot Password */}
                {/* <span className="text-right text-[#9C9C9C] text-xs cursor-pointer mt-2">
                  {forgotPassword}
                </span> */}
              </div>

              {/* Login Button */}
              {/* <button
                    className="bg-[#45185a] mt-12 text-sm text-white font-semibold py-4 rounded-xl shadow-md hover:shadow-lg transition mt-8"
                    style={button.style}
                    onClick={handleRegularLogin}
                >
                  {button.text}
                </button> */}

              <button
                className="border-[#45185a] border-2 mt-12 text-lg text-[#45185a] font-bold py-4 rounded-xl hover:shadow-lg transition mt-8"
                style={button.style}
                onClick={handleGoogleLogin}
              >
                <span className="flex items-center justify-evenly">
                  <span>Sign in with Gmail</span>
                  <span>
                    <img
                      src={googleSignIn.src}
                      alt={googleSignIn.alt}
                      className="w-6 h-6 cursor-pointer"
                    /></span>
                </span>
              </button>

              {/* Divider */}
              {/* <div className="flex items-center justify-center mt-8">
                <span className="text-gray-500 font-semibold text-sm">
                  {continueText}
                </span>
                </div> */}

              {/* Google Sign-In */}
              {/* <div className="flex justify-center mt-6">
                  <img
                      src={googleSignIn.src}
                      alt={googleSignIn.alt}
                      className="w-8 h-8 cursor-pointer"
                      onClick={handleGoogleLogin}
                  />
                </div>
                <div className="flex items-center justify-center mt-8">
                <span className="text-gray-500 font-semibold text-sm">
                  or Sign Up (v3)
                </span>
                </div> */}
              {/* Google Sign-In */}
              {/* <div className="flex justify-center mt-6">
                  <img
                      src={googleSignIn.src}
                      alt={googleSignIn.alt}
                      className="w-8 h-8 cursor-pointer"
                      onClick={handleGoogleSignup}
                  />
                </div> */}
            </div>
          </div>
        </div>
      </div>
      <ToastContainer/>
    </div>
  );
};

export default LoginScreen;